<div class="identity-map-container">
  <!-- Header con breadcrumb y botones -->
  <div class="header-row">
    <div class="header-left">
      <span class="breadcrumb">
        <a routerLink="/dashboard/descubrete">Descubrete</a> > 
        <span class="breadcrumb-active">Mapa de identidad</span>
      </span>
    </div>
    <!-- <div class="header-actions">
      <button class="btn-exit" (click)="exit()">Salir</button>
      <button class="btn-save" (click)="saveIdentityMapData()">Guardar</button>
    </div> -->
  </div>

  <!-- Título principal -->
  <div class="page-header">
    <h1 class="page-title">Mapa de identidad</h1>
    <p class="page-subtitle">Exploremos juntos tu identidad</p>
  </div>

  <!-- Sección Línea de vida -->
  <div class="section-container">
    <div class="section-header" (click)="toggleSection('life-line')">
      <span class="section-title">Línea de vida</span>
      <i class="fas" [ngClass]="isSectionExpanded('life-line') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>
    
    <div *ngIf="isSectionExpanded('life-line')" class="section-content">
      <!-- Debug info -->
        <!-- <div style="background: #f0f0f0; padding: 10px; margin: 10px 0; border-radius: 4px; font-size: 12px;">
          <strong>Debug:</strong><br>
          hasExistingLifeLineData: {{ hasExistingLifeLineData() }}<br>
          isSectionStarted: {{ isSectionStarted('life-line') }}<br>
          lifeLineCompleted: {{ lifeLineCompleted }}<br>
          peaks: {{ identityData?.lifeLine?.peaks?.length || 0 }}<br>
          valleys: {{ identityData?.lifeLine?.valleys?.length || 0 }}
        </div> -->
      
      <!-- Mensaje de bienvenida -->
      <div *ngIf="!hasExistingLifeLineData() && !isSectionStarted('life-line')" class="welcome-content">
        <h2>Línea de vida</h2>
        <p><strong>Este es tu espacio para mirar tu recorrido con sinceridad: celebra tus logros y reconoce los desafíos que has enfrentado</strong>. 
          Para enriquecer esta reflexión, <strong>piensa no solo en el corto plazo, sino en tu historia completa</strong>, desde tu niñez hasta hoy, abarcando lo personal y lo profesional.
          <strong>Cada hito es parte esencial de tu crecimiento y te ayudará a trazar un plan de vida más realista y significativo.</strong>
        </p>
        <button class="btn-start" (click)="startLifeLine()">Empezar</button>
      </div>

      <!-- Formulario de línea de vida con iceberg -->
      <div *ngIf="hasExistingLifeLineData() || isSectionStarted('life-line')" class="life-line-form">
        <!-- Vista Desktop: Mostrar ambos (picos y valles) -->
        <div class="life-line-desktop">
          <!-- Fondo del iceberg -->
          <div class="iceberg-background"></div>
          <div class="iceberg-container">
            <!-- Picos (arriba del agua) -->
            <div class="peaks-section">
              <div class="peaks-header">
                <div class="peaks-title">
                  <h3>Picos</h3>
                  <p><span class="list-highlight"><strong>Logros, cambios positivos, hitos personales</strong></span></p>
                </div>
                <div class="peaks-input">
                  <h4>Escribe aquí 5 picos:</h4>
                  <div class="input-container five-inputs">
                    <div *ngFor="let peak of [0,1,2,3,4]; let i = index" class="list-item peak-list-item">
                      <span class="bullet-point">•</span>
                      <input
                        type="text"
                        [(ngModel)]="identityData.lifeLine.peaks[i].text"
                        (ngModelChange)="onPeakInputChange(i, $event)"
                        placeholder="Termine de escribir y presione enter"
                        class="peak-input-main"
                        [attr.tabindex]="i + 1"
                        maxlength="120"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Línea de agua -->
            <div class="water-line"></div>

            <!-- Valles (abajo del agua) -->
            <div class="valleys-section">
              <div class="valleys-header">
                <div class="valleys-title">
                  <h3>Valles</h3>
                  <p>Retos, fracasos, aprendizajes clave</p>
                </div>
                <div class="valleys-input">
                  <h4>Escribe aquí 5 valles:</h4>
                  <div class="input-container five-inputs">
                    <div *ngFor="let valley of [0,1,2,3,4]; let i = index" class="list-item valley-list-item">
                      <span class="bullet-point">•</span>
                      <input
                        type="text"
                        [(ngModel)]="identityData.lifeLine.valleys[i].text"
                        (ngModelChange)="onValleyInputChange(i, $event)"
                        placeholder="Termine de escribir y presione enter"
                        class="valley-input-main"
                        [attr.tabindex]="i + 1"
                        maxlength="120"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button *ngIf="!hideLifeLineSection" class="btn-finish" (click)="finishLifeLine()">Finalizar</button>
        </div>

        <!-- Vista Móvil: Mostrar en 2 steps -->
        <div class="life-line-mobile">
          <!-- Step 1: Picos -->
          <div *ngIf="currentLifeLineStep === 0" class="mobile-step mobile-step-peaks">
            <div class="mobile-step-card">
              <div class="mobile-step-header">
                <h3>Picos</h3>
                <p>Logros, cambios positivos, hitos personales</p>
              </div>
              <div class="mobile-step-input">
                <h4>Escribe aqui:</h4>
                <div class="input-container mobile-inputs-container">
                  <input 
                    *ngFor="let input of mobilePeakInputs; let i = index; trackBy: trackByIndex"
                    type="text" 
                    [(ngModel)]="mobilePeakInputs[i]"
                    (blur)="updateMobilePeak(i, mobilePeakInputs[i])"
                    [placeholder]="'• Ingrese aqui'"
                    class="mobile-input-item">
                </div>
              </div>
              <button class="btn-continue" (click)="continueToValleys()">Continuar</button>
            </div>
          </div>

          <!-- Step 2: Valles -->
          <div *ngIf="currentLifeLineStep === 1" class="mobile-step mobile-step-valleys">
            <div class="mobile-step-card">
              <div class="mobile-step-header">
                <h3>Valles</h3>
                <p>Retos, fracasos, aprendizajes clave</p>
              </div>
              <div class="mobile-step-input">
                <h4>Escribe aqui:</h4>
                <div class="input-container mobile-inputs-container">
                  <input 
                    *ngFor="let input of mobileValleyInputs; let i = index; trackBy: trackByIndex"
                    type="text" 
                    [(ngModel)]="mobileValleyInputs[i]"
                    (blur)="updateMobileValley(i, mobileValleyInputs[i])"
                    [placeholder]="'• Ingrese aqui'"
                    class="mobile-input-item">
                </div>
              </div>
              <button class="btn-finish-mobile" *ngIf="!lifeLineCompleted" (click)="finishLifeLine()">Finalizar</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Sección Mi pasado -->
  <div class="section-container">
    <div class="section-header" (click)="toggleSection('past')">
      <span class="section-title">Mi pasado</span>
      <i class="fas" [ngClass]="isSectionExpanded('past') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>
    
    <div *ngIf="isSectionExpanded('past')" class="section-content">
      
      <!-- Mensaje de bienvenida -->
      <div *ngIf="!isSectionStarted('past')" class="welcome-content">
        <h2>Hilo conductor</h2>
        <p>Ahora que has identificado tus picos y valles,<strong> es momento de reflexionar más a fondo.</strong> Piensa en cuáles de esos momentos marcaron tu orgullo y cuáles
           te dejaron aprendizajes que todavía llevas contigo. Este ejercicio te ayudará a <strong> reconocer los valores y capacidades</strong> que se repiten en tu historia y 
           que forman parte de tu identidad</p>
        <button class="btn-start" (click)="startPast()">Empezar</button>
      </div>

      <!-- Formulario de preguntas del pasado -->
      <div *ngIf="isSectionStarted('past') && !pastCompleted" class="past-form">
        <div class="form-header">
          <span class="progress-text">Sección {{ currentPastSection + 1 }} de {{ identityData.pastQuestions.length }}</span>
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="((currentPastSection + 1) / identityData.pastQuestions.length) * 100"></div>
          </div>
        </div>

        <div class="question-block">
          <div class="question-number">{{ currentPastSection + 1 }}</div>
          <div class="question-content">
            <p class="question-text">{{ identityData.pastQuestions[currentPastSection].text }}</p>
            <div class="answer-input">
              <input 
                type="text"
                [(ngModel)]="identityData.pastQuestions[currentPastSection].answer"
                placeholder="Ingrese respuesta"
                class="text-input">
            </div>
          </div>
        </div>

        <div class="form-navigation">
          <button 
            class="btn-continue" 
            [disabled]="!isCurrentPastSectionCompleted()"
            (click)="currentPastSection === 4 ? saveMiPasado() : nextPastSection()">
            {{ getPastContinueButtonText() }}
          </button>
          <button 
            *ngIf="currentPastSection > 0"
            class="btn-previous" 
            (click)="previousPastSection()">
            ← Anterior
          </button>
        </div>
      </div>

      <!-- Mensaje de finalización - Solo cuando se completa pero no está guardado -->
      <div *ngIf="pastCompleted && !isMiPasadoCompletedAndSaved()" class="completion-content">
        <h2>¡Felicitaciones!</h2>
        <p>Cada logro y cada reto deja una huella. Al identificar los aprendizajes y patrones en tu historia, estarás construyendo tu propio hilo conductor: aquello que te define y te guía hacia tus próximos pasos.</p>
        <button class="btn-finish" (click)="finishPast()">Finalizar</button>
      </div>

      <!-- Resumen de "Mi pasado" - Solo si está completado y guardado -->
      <div *ngIf="isMiPasadoCompletedAndSaved()" class="past-summary-container">
        <div class="summary-header">
          <h3>Resumen de "Mi pasado"</h3>
          <p class="summary-subtitle">Aquí tienes un resumen de tus reflexiones sobre tu historia personal</p>
        </div>
        
        <!-- Preguntas y respuestas -->
        <div class="past-questions-summary">
          <h4>Reflexiones sobre tu historia</h4>
          <div class="past-questions-items">
            <div *ngFor="let question of identityData.pastQuestions; let i = index" class="past-question-item">
              <div class="question-number">{{ i + 1 }}</div>
              <div class="question-content">
                <div class="question-text">{{ question.text }}</div>
                <div class="answer-container">
                  <div class="answer-label">Respuesta {{ i + 1 }}</div>
                  <div class="answer-line"></div>
                  <div class="answer-text">{{ question.answer || '' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-actions">
          <button class="btn-edit" (click)="editPastSection()">
            <!-- <span class="btn-icon">✏️</span> -->
            Editar respuestas
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección Mi presente -->
  <div class="section-container">
    <div class="section-header" (click)="toggleSection('present')">
      <span class="section-title">Mi presente</span>
      <i class="fas" [ngClass]="isSectionExpanded('present') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>
    
    <div *ngIf="isSectionExpanded('present')" class="section-content">
      <!-- Mensaje de bienvenida -->
      <div *ngIf="!isSectionStarted('present')" class="welcome-content">
        <h2>Matriz de energía y desempeño</h2>
        <p>
          En esta dinámica explorarás tu presente organizando tus actividades en una <strong> matriz que cruza dos dimensiones</strong>: lo que haces bien o mal, y lo que te energiza o te drena.
           El objetivo es que <strong> reconozcas con claridad cuáles son tus fortalezas que vale la pena potenciar</strong>, qué <strong>actividades representan un riesgo porque te desgastan</strong> aunque las hagas bien, 
           <strong> qué oportunidades de aprendizaje puedes aprovechar</strong> en aquello que aún no dominas pero disfrutas, y finalmente qué <strong> tareas deberías evitar</strong> porque no aportan valor y solo consumen tu energía.
        </p>
        <button class="btn-start" (click)="startPresent()">Empezar</button>
      </div>

      <!-- Paso 0: Matriz 2x2 -->
      <div *ngIf="isSectionStarted('present') && !presentCompleted && currentPresentStep === 0" class="present-matrix">
        <div class="matrix-title">
          <p>Organiza tus actividades según lo que haces bien o mal, y lo que te energiza o drena. Escribe hasta 3 ideas por cuadrante.</p>
        </div>
        <div class="matrix-container">
          <!-- Etiquetas de ejes horizontales -->
          <div class="axis-labels-horizontal">
            <div class="axis-label horizontal left">Me drena</div>
            <div class="axis-label horizontal right">Me energiza</div>
          </div>
          
          <div class="matrix-grid">
            <!-- Etiquetas de ejes verticales -->
            <div class="axis-labels-vertical">
              <div class="axis-label vertical top">Hago bien</div>
              <div class="axis-label vertical bottom">Hago mal</div>
            </div>
            
            <!-- Cuadrantes -->
            <div class="quadrants-container">
              <!-- Riesgo (Hago bien + Me drena) - Top Left -->
              <div class="quadrant riesgo">
                <div class="quadrant-header">Riesgo</div>
                <div class="quadrant-description">Lo hago bien y me drena</div>
                <div class="quadrant-content">
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[1].items[0]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[1].items[1]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[1].items[2]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                </div>
              </div>

              <!-- Fortaleza (Hago bien + Me energiza) - Top Right -->
              <div class="quadrant fortaleza">
                <div class="quadrant-header">Fortaleza</div>
                <div class="quadrant-description">Lo hago bien y me energiza</div>
                <div class="quadrant-content">
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[0].items[0]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[0].items[1]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[0].items[2]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                </div>
              </div>

              <!-- Evitar (Hago mal + Me drena) - Bottom Left -->
              <div class="quadrant evitar">
                <div class="quadrant-header">Evitar</div>
                <div class="quadrant-description">Lo hago mal y me drena</div>
                <div class="quadrant-content">
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[3].items[0]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[3].items[1]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[3].items[2]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                </div>
              </div>

              <!-- Aprendizaje (Hago mal + Me energiza) - Bottom Right -->
              <div class="quadrant aprendizaje">
                <div class="quadrant-header">Aprendizaje</div>
                <div class="quadrant-description">Lo hago mal y me energiza</div>
                <div class="quadrant-content">
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[2].items[0]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[2].items[1]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                   <div class="input-item">
                     <input 
                       type="text" 
                       [(ngModel)]="identityData.presentQuadrants[2].items[2]"
                       placeholder="• Ingrese aqui"
                       class="quadrant-input">
                   </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="btn-continue" (click)="continuePresent()">{{ getPresentContinueButtonText() }}</button>
      </div>

      <!-- Paso 1: Reflexión final -->
      <div *ngIf="isSectionStarted('present') && !presentCompleted && currentPresentStep === 1" class="present-intro">
        <h2>Reflexión final: Enfoque de Energía</h2>
        <p>Has identificado <strong> lo que te da energía y lo que te drena</strong>. Ahora es momento de dar un paso más: <strong> elige una actividad que vas a dejar atrás </strong> porque no
           te aporta valor (stop-doing) <strong> y una en la que quieres invertir más energía </strong> porque potencia tu crecimiento (doblar la apuesta). Esta reflexión te
            ayudará a <strong> enfocar tu presente y alinear tu camino hacia tu plan de vida</strong>.</p>
        <button class="btn-continue" (click)="continuePresent()">{{ getPresentContinueButtonText() }}</button>
      </div>

      <!-- Paso 2: Preguntas stop-doing y doblar apuesta -->
      <div *ngIf="isSectionStarted('present') && !presentCompleted && currentPresentStep === 2" class="present-questions">
        <!-- Pregunta 1: Stop-doing -->
        <div class="question-container">
          <div class="question-number">1</div>
          <div class="question-content">
            <p class="question-text">Stop-doing. Escribe una actividad que vas a dejar de hacer (o reducir) porque no te aporta valor y te drena energía.</p>
            <div class="answer-input">
              <input 
                type="text" 
                [(ngModel)]="identityData.stopDoing"
                placeholder="Ingrese respuesta"
                class="text-input">
            </div>
          </div>
        </div>

        <!-- Pregunta 2: Doblar la apuesta -->
        <div class="question-container">
          <div class="question-number">2</div>
          <div class="question-content">
            <p class="question-text">Doblar la apuesta. Elige una actividad que te da energía y valor, en la que quieras invertir más tiempo y esfuerzo para potenciar tus resultados.</p>
            <div class="answer-input">
              <input 
                type="text" 
                [(ngModel)]="identityData.doubleDown"
                placeholder="Ingrese respuesta"
                class="text-input">
            </div>
          </div>
        </div>

        <div class="form-navigation">
          <button class="btn-previous" (click)="previousPresentStep()">← Atrás</button>
          <button class="btn-continue" (click)="continuePresent()" [disabled]="!isCurrentPresentStepCompleted()">{{ getPresentContinueButtonText() }}</button>
        </div>
      </div>

      <!-- Paso 3: Felicidades con objetivos -->
      <div *ngIf="isSectionStarted('present') && !presentCompleted && currentPresentStep === 3" class="present-congratulations">
        <h2>¡Felicidades!</h2>
        <p>Cada decisión que tomas sobre dónde poner tu energía te acerca a un futuro más claro y motivador. Has identificado qué dejar ir y en qué apostar más fuerte: ahora usa esas respuestas como inspiración para escribir tus primeros objetivos. Recuerda transformar tus reflexiones en metas concretas es el siguiente paso para avanzar con propósito.
           <!-- Escribe tus primeros objetivos <a (click)="saveAndRedirectToObjectives($event)" class="objectives-link">AQUÍ</a> -->
          </p>
        <button class="btn-finish" (click)="saveAndShowSummary()">Finalizar</button>
      </div>
      <!-- Resumen de resultados -->
      <div *ngIf="isMiPresenteCompletedAndSaved() && !showPresentCongratulations" class="present-summary-container">
        <div class="summary-header">
          <h3>Resumen de "Mi presente"</h3>
          <p class="summary-subtitle">Aquí tienes un resumen de tus reflexiones y decisiones</p>
        </div>
        
        <!-- Matriz 2x2 -->
        <div class="matrix-summary">
          <div class="matrix-container">
            <!-- Etiquetas de ejes horizontales -->
            <div class="axis-labels-horizontal">
              <div class="axis-label horizontal left">Me drena</div>
              <div class="axis-label horizontal right">Me energiza</div>
            </div>
            
            <div class="matrix-grid">
              <!-- Etiquetas de ejes verticales -->
              <div class="axis-labels-vertical">
                <div class="axis-label vertical top">Hago bien</div>
                <div class="axis-label vertical bottom">Hago mal</div>
              </div>
              
              <!-- Cuadrantes -->
              <div class="quadrants-container">
                <!-- Riesgo (Hago bien + Me drena) -->
                <div class="quadrant riesgo">
                  <div class="quadrant-header">Riesgo</div>
                  <div class="quadrant-description">Lo hago bien y me drena</div>
                  <div class="quadrant-content">
                    <div class="input-item" *ngFor="let item of identityData.presentQuadrants[1].items">
                      <div class="quadrant-item-text" *ngIf="item.trim()">• {{ item }}</div>
                      <div class="quadrant-item-placeholder" *ngIf="!item.trim()">• Ingrese aqui</div>
                    </div>
                  </div>
                </div>

                <!-- Fortaleza (Hago bien + Me energiza) -->
                <div class="quadrant fortaleza">
                  <div class="quadrant-header">Fortaleza</div>
                  <div class="quadrant-description">Lo hago bien y me energiza</div>
                  <div class="quadrant-content">
                    <div class="input-item" *ngFor="let item of identityData.presentQuadrants[0].items">
                      <div class="quadrant-item-text" *ngIf="item.trim()">• {{ item }}</div>
                      <div class="quadrant-item-placeholder" *ngIf="!item.trim()">• Ingrese aqui</div>
                    </div>
                  </div>
                </div>

                <!-- Evitar (Hago mal + Me drena) -->
                <div class="quadrant evitar">
                  <div class="quadrant-header">Evitar</div>
                  <div class="quadrant-description">Lo hago mal y me drena</div>
                  <div class="quadrant-content">
                    <div class="input-item" *ngFor="let item of identityData.presentQuadrants[3].items">
                      <div class="quadrant-item-text" *ngIf="item.trim()">• {{ item }}</div>
                      <div class="quadrant-item-placeholder" *ngIf="!item.trim()">• Ingrese aqui</div>
                    </div>
                  </div>
                </div>

                <!-- Aprendizaje (Hago mal + Me energiza) -->
                <div class="quadrant aprendizaje">
                  <div class="quadrant-header">Aprendizaje</div>
                  <div class="quadrant-description">Lo hago mal y me energiza</div>
                  <div class="quadrant-content">
                    <div class="input-item" *ngFor="let item of identityData.presentQuadrants[2].items">
                      <div class="quadrant-item-text" *ngIf="item.trim()">• {{ item }}</div>
                      <div class="quadrant-item-placeholder" *ngIf="!item.trim()">• Ingrese aqui</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Preguntas de reflexión -->
        <div class="reflection-summary">
          <h4>Reflexiones</h4>
          <div class="reflection-items">
            <div class="reflection-item">
              <div class="question-number">1</div>
              <div class="question-content">
                <div class="question-text">Stop-doing. Escribe una actividad que vas a dejar de hacer (o reducir) porque no te aporta valor y te drena energía.</div>
                <div class="answer-container">
                  <div class="answer-label">Respuesta 1</div>
                  <div class="answer-line"></div>
                  <div class="answer-text">{{ identityData.stopDoing || '' }}</div>
                </div>
              </div>
            </div>
            <div class="reflection-item">
              <div class="question-number">2</div>
              <div class="question-content">
                <div class="question-text">Doblar la apuesta. Elige una actividad que te da energía y valor, en la que quieras invertir más tiempo y esfuerzo para potenciar tus resultados.</div>
                <div class="answer-container">
                  <div class="answer-label">Respuesta 2</div>
                  <div class="answer-line"></div>
                  <div class="answer-text">{{ identityData.doubleDown || '' }}</div>
                </div>
              </div>
            </div>
            <div class="reflection-item">
              <div class="question-number">3</div>
              <div class="question-content">
                <div class="question-text">Objetivos</div>
                <div class="answer-container">
                  <div class="answer-label">Respuesta 3</div>
                  <div class="answer-line"></div>
                  <div class="answer-text">{{ identityData.objectives || '' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-actions">
          <button class="btn-edit" (click)="editPresentSection()">
            <!-- <span class="btn-icon">✏️</span> -->
            Editar respuestas
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Botón para limpiar todas las respuestas -->
  <!-- <div class="clear-all-container">
    <button class="btn-clear-all" (click)="clearAllData()">
      <span class="btn-icon">🗑️</span>
      Limpiar todas las respuestas
    </button>
  </div> -->
</div>
